module.exports = __webpack_public_path__ + "static/media/bellabyte-folder-informativo.2b385dae.jpg";